import { AccionModificacionFeriado } from "@shared/enums/AccionModificacionFeriado";

export class FeriadoDTO {
  id: string;
  fecha: string;
  motivo: string;
  activo: boolean;
  modificaciones: ModificacionFeriadoDTO[];
}

export class ModificacionFeriadoDTO {
  id: string;
  responsable: string;
  accion: AccionModificacionFeriado;
  fechaHora: string;
  motivo: string;
  activo: boolean
}
